import { deviceScheduleData } from "../actionTypes"

// Merges a patch into the cached Device Schedule page state.
export const setDeviceSchedule = (data) => {
    return {
        type: deviceScheduleData.MERGE,
        payload: data
    }
}
